module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0029.a8cfd5ea.jpg";